import type { ComponentProps } from 'react';
import Card from '@/components/UI/Card';
import OBVLineAuditChart from '../OBVLineAuditChart';
import MetricPill from './MetricPill';
import type { ObvChartWindow } from './types';

interface ObvLineSignalCardProps {
    chartWindow: ObvChartWindow;
    obvChartMarkers: ComponentProps<typeof OBVLineAuditChart>['eventMarkers'];
    obvChartPoints: ComponentProps<typeof OBVLineAuditChart>['points'];
    selectedDateTime: string | null;
}

const ObvLineSignalCard = ({ chartWindow, obvChartMarkers, obvChartPoints, selectedDateTime }: ObvLineSignalCardProps) => (
    <Card responsivePadding bodyClassName="space-y-4" title="OBV Line And Signal">
        {obvChartPoints.length === 0 ? (
            <div className="text-sm text-zinc-400">No OBV state history fell inside the visible chart window.</div>
        ) : (
            <>
                <div className="grid gap-3 md:grid-cols-2 xl:grid-cols-4">
                    <MetricPill label="Visible OBV Bars" value={String(obvChartPoints.length)} />
                    <MetricPill label="Focused DateTime" value={selectedDateTime ?? 'n/a'} />
                    <MetricPill label="Chart Start" value={chartWindow.startDateTime} />
                    <MetricPill label="Chart End" value={chartWindow.endDateTime} />
                </div>
                <OBVLineAuditChart eventMarkers={obvChartMarkers} focusedDateTime={selectedDateTime} points={obvChartPoints} />
            </>
        )}
    </Card>
);

export default ObvLineSignalCard;
